import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Main from './pages/Main';
import RoomCreated from './pages/RoomCreated';
import GameRoom from './pages/GameRoom';
import Disconnected from './pages/Disconnected';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/room/created/:roomId" element={<RoomCreated />} />
        <Route path="/host/:roomId" element={<GameRoom />} />
        <Route path="/guest/:roomId" element={<GameRoom />} />
        <Route path="/disconnected" element={<Disconnected />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App; 